import { render, staticRenderFns } from "./DocsHome.vue?vue&type=template&id=588576b1&scoped=true"
import script from "./DocsHome.vue?vue&type=script&lang=js"
export * from "./DocsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588576b1",
  null
  
)

export default component.exports